<template>
  <v-card outlined class="card-data-tles" :height="400">
    <v-card-title class="card-title-data-tles"> Data</v-card-title>
    <v-card-text class="card-content-data-tles"
      ><div class="text-h6" style="margin-bottom: 20px">
        TLEs
        <span v-if="TLEErrorMessage"> imported are not Valid</span>
        <span v-else>
          - {{ nbImportedTLEs > 1 ? nbImportedTLEs : 'Not enough' }} TLEs
          currently imported
        </span>
      </div>
      <v-row v-if="nbImportedTLEs < 10000">
        <v-textarea
          v-on:keyup.enter="$event.stopPropagation()"
          style="font-family: monospace"
          v-model="TLEText"
          label="Import TLEs from files or paste a list of TLEs here."
          full-width
          outlined
          :error-messages="TLEErrorMessage"
          :disabled="disabled"
          rows="3"
        ></v-textarea>
      </v-row>
      <v-row v-else class="mt-10 d-flex align-center">
        <span class="info--text mr-3" style="font-size: 110%"
          >{{ nbImportedTLEs }} TLEs have been imported (data is not displayed
          for performance reasons)</span
        >
        <v-btn
          outlined
          :disabled="disabled"
          color="red lighten--1"
          @click="TLEText = ''"
          >Clear data
        </v-btn>
      </v-row>
      <v-row class="mb-4">
        <v-btn
          class="mr-4"
          color="primary"
          rounded
          style="margin-top: 15px; width: 100%"
          :disabled="disabled"
          @click="openImportDialogue(true)"
          >Import TLEs from file
        </v-btn>
        <v-btn
          color="primary"
          :disabled="disabled"
          rounded
          style="margin-top: 15px; width: 100%"
          @click="openImportDialogue(false)"
          >Import TLEs from folder
        </v-btn>
        <v-dialog
          scrollable
          width="700"
          v-model="importDialog"
          :persistent="importing"
        >
          <TLEImportDialog
            :isOpenDialog.sync="importDialog"
            :filesOnly="importFilesOnly"
            v-on:update:tleText="TLEText = $event"
            v-on:update:importing="importing = $event"
          /> </v-dialog
      ></v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import tooltipScreeningCatalogueAnalysis from '../../components/Tooltips/Defense/tooltipScreeningCatalogueAnalysis'
import TLEImportDialog from './TLEImportDialog'
export default {
  name: 'measurementsSelector',
  mixins: [],
  components: {
    tooltipScreeningCatalogueAnalysis,
    TLEImportDialog
  },
  props: {
    tlesInput: Array,
    isValidInput: Boolean,
    disabled: Boolean
  },
  watch: {
    isValidTLEs(newValue) {
      this.$emit('update:isValidInput', newValue)
    }
  },
  computed: {
    TLEText: {
      get() {
        if (this.wrongTLEText == null) {
          return this.tlesInput.reduce(
            (TLEText, TLE) => TLE[0] + '\n' + TLE[1] + '\n' + TLEText,
            ''
          )
        } else {
          return this.wrongTLEText
        }
      },
      set(newValue) {
        const newTLEs = this.parseTLEs(newValue)
        if (newTLEs == null) {
          this.wrongTLEText = Object.freeze(newValue)
          this.$emit('update:tlesInput', [])
        } else {
          this.wrongTLEText = null
          this.$emit('update:tlesInput', Object.freeze(newTLEs))
        }
      }
    },

    isValidTLEs() {
      return this.wrongTLEText == null && this.nbImportedTLEs > 1
    },
    TLEErrorMessage() {
      return this.wrongTLEText == null ? '' : 'The imported TLEs are invalid.'
    },
    nbImportedTLEs() {
      return this.tlesInput?.length || 0
    }
  },

  data() {
    return {
      wrongTLEText: null,
      importDialog: false,
      importFilesOnly: false,
      importing: false,
      currentlyDisplayed: [0, 1]
    }
  },
  methods: {
    parseTLEs(TLEText) {
      const regex_tle =
        /\s*(?:(?<name>.{1,50})\s*\n)?\s*(?<l1>.{69})\s*\n\s*(?<l2>.{69})\s*/g
      const tles = []
      const matches = [...TLEText.matchAll(regex_tle)]
      let newText = ''
      matches.forEach((TLE) => {
        newText += TLE[0]
        tles.push([TLE.groups.l1, TLE.groups.l2])
      })
      if (newText.length === TLEText.length) {
        return tles.reverse()
      } else {
        return null
      }
    },
    openImportDialogue(importFilesOnly) {
      this.importFilesOnly = importFilesOnly
      this.importDialog = true
    }
  }
}
</script>

<style scoped>
.card-data-tles {
  border: 2px solid;
  border-color: black;
}
.card-title-data-tles {
  justify-content: center;
  align-content: center;
  font-size: small;
  border-bottom: 2px solid;
  border-color: black;
  height: 15px;
}
.card-content-data-tles {
  height: 350px;
  overflow-y: scroll;
  scrollbar-width: none;
}
</style>
